import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GridService } from './grid.service';

@Injectable({
  providedIn: 'root'
})
export class AiService {

  constructor(private gridService:GridService) { }

  getPrompts(scope:string): Observable<any> {
    return this.gridService.getScopeData('AIPROMPTS', 'READ', { ViewCode:"AIPROMPTS.DEFAULT", Filter: JSON.stringify({ScopeCode: scope}) });
  }

}
